import { collectionRef, db, workersRef } from "./firebase";
const WORKERS_DEV = "workersDev";
const WORKERS = "workers";

export const saveWorkerScheduleData = async (data, workerId) => {
  console.log(
    "services > workerSchedule > saveWorkerScheduleEntries called..."
  );
  return new Promise((res, rej) => {
    try {
      if (data == null) {
        return rej(new Error("Data is null"));
      }
      return collectionRef(WORKERS_DEV)
        .doc(workerId)
        .collection("workersSchedule")
        .add(data)
        .then((snapshot) => {
          console.log("Document successfully written to firestore!");
          res(snapshot.id);
        });
    } catch (error) {
      console.error(
        "in services > workerSchedule > saveWorkerScheduleEntries, err===" +
          error
      );
      rej(error);
    }
  });
};

export const getWorkerSchedule = async (workerId) => {
  console.log("services > workerSchedule > getWorkerSchedule called...");
  return new Promise((res, rej) => {
    try {
      if (workerId == null) {
        return rej(new Error("workerId is null"));
      }
      return workersRef()
        .doc(workerId)
        .collection("workersSchedule")
        .doc(workerId)
        .get()
        .then((snapshot) => {
          console.log(
            "in services > workerSchedule > getWorkerSchedule [SUCCESS]"
          );
          res(snapshot.data() || {});
        });
    } catch (error) {
      console.error(
        "in services > workerSchedule > getWorkerSchedule, err===" + error
      );
      rej(error);
    }
  });
};

export const getWorkerGdeRole = async (workerId) => {
  console.log("services > workerSchedule > getWorkerSchedule called...");
  return new Promise((res, rej) => {
    try {
      if (workerId == null) {
        return rej(new Error("workerId is null"));
      }
      return workersRef()
        .doc(workerId)
        .collection("workerRoles")
        .doc("gde")
        .get()
        .then((snapshot) => {
          console.log(
            "in services > workerSchedule > getWorkerSchedule [SUCCESS]"
          );
          res(snapshot.data() || {});
        });
    } catch (error) {
      console.error(
        "in services > workerSchedule > getWorkerSchedule, err===" + error
      );
      rej(error);
    }
  });
};

export const getWorkerTransportRole = async (workerId) => {
  console.log("services > workerSchedule > getWorkerTransportRole called...");
  return new Promise((res, rej) => {
    try {
      if (workerId == null) {
        return rej(new Error("workerId is null"));
      }
      return workersRef()
        .doc(workerId)
        .collection("workerRoles")
        .doc("transportation")
        .get()
        .then((snapshot) => {
          console.log(
            "in services > workerSchedule > getWorkerTransportRole [SUCCESS]"
          );
          res(snapshot.data() || {});
        });
    } catch (error) {
      console.error(
        "in services > workerSchedule > getWorkerSchedule, err===" + error
      );
      rej(error);
    }
  });
};

export const getWorkerSBSRole = async (workerId) => {
  console.log("services > workerSchedule > getWorkerSBSRole called...");
  return new Promise((res, rej) => {
    try {
      if (workerId == null) {
        return rej(new Error("workerId is null"));
      }
      return workersRef()
        .doc(workerId)
        .collection("workerRoles")
        .doc("SBS")
        .get()
        .then((snapshot) => {
          console.log(
            "in services > workerSchedule > getWorkerSBSRole [SUCCESS]"
          );
          res(snapshot.data() || {});
        });
    } catch (error) {
      console.error(
        "in services > workerSchedule > getWorkerSBSRole, err===" + error
      );
      rej(error);
    }
  });
};
export const getWorkerSecurebaseRole = async (workerId) => {
  console.log("services > workerSchedule > getWorkerSecurebaseRole called...");
  return new Promise((res, rej) => {
    try {
      if (workerId == null) {
        return rej(new Error("workerId is null"));
      }
      return workersRef()
        .doc(workerId)
        .collection("workerRoles")
        .doc("securebase")
        .get()
        .then((snapshot) => {
          console.log(
            "in services > workerSchedule > getWorkerSecurebaseRole [SUCCESS]"
          );
          res(snapshot.data() || {});
        });
    } catch (error) {
      console.error(
        "in services > workerSchedule > getWorkerSecurebaseRole, err===" + error
      );
      rej(error);
    }
  });
};
export const getWorkerCrozierRole = async (workerId) => {
  console.log("services > workerSchedule > getWorkerCrozierRole called...");
  return new Promise((res, rej) => {
    try {
      if (workerId == null) {
        return rej(new Error("workerId is null"));
      }
      return workersRef()
        .doc(workerId)
        .collection("workerRoles")
        .doc("crozier")
        .get()
        .then((snapshot) => {
          console.log(
            "in services > workerSchedule > getWorkerCrozierRole [SUCCESS]"
          );
          res(snapshot.data() || {});
        });
    } catch (error) {
      console.error(
        "in services > workerSchedule > getWorkerCrozierRole, err===" + error
      );
      rej(error);
    }
  });
};
export const getWorkerIMTimeRole = async (workerId) => {
  console.log("services > workerSchedule > getWorkerIMTimeRole called...");
  return new Promise((res, rej) => {
    try {
      if (workerId == null) {
        return rej(new Error("workerId is null"));
      }
      return workersRef()
        .doc(workerId)
        .collection("workerRoles")
        .doc("timeRole")
        .get()
        .then((snapshot) => {
          console.log(
            "in services > workerSchedule > getWorkerIMTimeRole [SUCCESS]"
          );
          res(snapshot.data() || {});
        });
    } catch (error) {
      console.error(
        "in services > workerSchedule > getWorkerIMTimeRole, err===" + error
      );
      rej(error);
    }
  });
};
export const getWorkerGorpaRole = async(workerId)=>{
  console.log("services > workerSchedule > getWorkerGorpaRole called...");
  return new Promise((res, rej) => {
    try {
      if (workerId == null) {
        return rej(new Error("workerId is null"));
      }
      return workersRef()
        .doc(workerId)
        .collection("workerRoles")
        .doc("gorpa")
        .get()
        .then((snapshot) => {
          console.log(
            "in services > workerSchedule > getWorkerGorpaRole [SUCCESS]"
          );
          res(snapshot.data() || {});
        });
    } catch (error) {
      console.error(
        "in services > workerSchedule > getWorkerGorpaRole, err===" + error
      );
      rej(error);
    }
  });
};
export const getSmartSortUserRole = async (workerId) => {
  console.log("services > workerSchedule > getWorkerSmartSortRole called...");
  return new Promise((res, rej) => {
    try {
      if (workerId == null) {
        return rej(new Error("workerId is null"));
      }
      return workersRef()
        .doc(workerId)
        .collection("workerRoles")
        .doc("ONEIL")
        .get()
        .then((snapshot) => {
          console.log(
            "in services > workerSchedule > getWorkerSBSRole [SUCCESS]"
          );
          res(snapshot.data() || {});
        });
    } catch (error) {
      console.error(
        "in services > workerSchedule > getWorkerSmartSortRole, err===" + error
      );
      rej(error);
    }
  });
};


